__turbopack_context__.v({
  "hidden": "ImageWithToaster-module__rZp0_a__hidden",
  "image": "ImageWithToaster-module__rZp0_a__image",
  "toasterFrame": "ImageWithToaster-module__rZp0_a__toasterFrame",
});
